import { collection, onSnapshot } from 'firebase/firestore';
import { database } from '../../config/firebase';
import { thisOscarsYear } from '../../config/constants';
import { queueUpdate } from '../../util/spoilerDelayBuffer';

let watchBallotScores = () =>
  onSnapshot(
    collection(database, 'derived_state', String(thisOscarsYear), 'scores'),
    collectionSnapshot => {
      let scores: Record<string, { score: number; strictScore: number }> = {};
      collectionSnapshot.forEach(doc => {
        let data = doc.data();
        scores[doc.id] = {
          score: data.score,
          strictScore: data.strictScore,
        };
      });

      queueUpdate('scores', scores);
    }
  );

export default watchBallotScores;
